<template>
  <div class="tokenInfo">
    <div class="tokenInfo_symbol_name">
      <div class="tokenInfo_symbolTitle">
        <em class="tokenInfo_symbolIconBox">{{trade||''}}</em>
      </div>
      <div class="tokenInfo_pricePrecision"> 
        <!-- rgb(236, 77, 92) 红  rgb(107, 185, 109) 绿 -->
        <p class="tokenInfo_price" :style="upDown===0?' color: rgb(236, 77, 92);':' color: rgb(107, 185, 109);'" 
        v-show="(tradeInfo.askPrice-tradeInfo.openPrice)/tradeInfo.openPrice*100>0"> 
          {{tradeInfo.askPrice2|digits2(tradeInfo.tickSize)}}
        </p>
        <p class="tokenInfo_price" :style="upDown===1?' color: rgb(236, 77, 92);':' color: rgb(107, 185, 109);'" 
        v-show="(tradeInfo.askPrice-tradeInfo.openPrice)/tradeInfo.openPrice*100<=0"> 
          {{tradeInfo.askPrice2|digits2(tradeInfo.tickSize)}}
        </p>
      </div>
    </div>
    <div class="tokenInfo_info">
      <div class="tokenInfo_infoRow">
        <div class="tokenInfo_infoCol">  
          <div class="tokenInfo_infoCell">
            <span class="tokenInfo_infoIntro">{{$t('12927')}}</span>
                {{tradeInfo.highPrice|digits2(tradeInfo.tickSize)}}
          </div>
          <div class="tokenInfo_infoCell">
            <span class="tokenInfo_infoIntro">{{$t('12928')}}</span>
              {{tradeInfo.lowPrice|digits2(tradeInfo.tickSize)}}
          </div>
        </div>
        <div class="tokenInfo_infoCol">
          <div class="tokenInfo_infoCell">
            <span class="tokenInfo_infoIntro">
              {{$t('12930')}}
            </span>
            <i :style="upDown===0?' color: rgb(236, 77, 92);':' color: rgb(107, 185, 109);'" v-show="(tradeInfo.askPrice2-tradeInfo.openPrice)/tradeInfo.openPrice*100>0">
              <i v-show="(tradeInfo.askPrice2-tradeInfo.openPrice)/tradeInfo.openPrice*100>0" :style="upDown===0?' color: rgb(236, 77, 92);':' color: rgb(107, 185, 109);'">+</i>
              {{(tradeInfo.askPrice2-tradeInfo.openPrice)/tradeInfo.openPrice*100|fixedNum(2)}}%
            </i>
            <i :style="upDown===1?' color: rgb(236, 77, 92);':' color: rgb(107, 185, 109);'" v-show="(tradeInfo.askPrice2-tradeInfo.openPrice)/tradeInfo.openPrice*100<=0">
              <i v-show="(tradeInfo.askPrice2-tradeInfo.openPrice)/tradeInfo.openPrice*100>0" :style="upDown===0?' color: rgb(236, 77, 92);':' color: rgb(107, 185, 109);'">+</i>{{(tradeInfo.askPrice2-tradeInfo.openPrice)/tradeInfo.openPrice*100|fixedNum(2)}}%</i>
          </div>
          <div class="tokenInfo_infoCell">
            <span class="tokenInfo_infoIntro">
              {{$t('12931')}} 
              <!-- 成交量 -->
            </span> 
                {{tradeInfo.volume|toLocaleString(tradeInfo.tickSize)}} {{tradeInfo.baseAsset}}
          </div>
        </div>
      </div>
      <div class="tokenInfo_infoRow">
        <div class="tokenInfo_infoCell">
          <span class="tokenInfo_infoIntro">
            {{$t('12929')}}
            <!-- 24h成交额 -->
          </span>
                {{tradeInfo.quoteVolume|moneyFormats}}
        </div>
      </div>
    </div>
    <div class="tokenInfo_scoreBox" v-show="score">
      <a :href="this.bitUrl" target="_blank" rel="noreferrer">
        <h4 class="tokenInfo_scoreTitle">
          <span>{{baseAsset}}</span>
          <i>{{$t('31300')}}</i>
          <!-- <i>{{$t('9127')}}</i> -->

        </h4>
        <p class="tokenInfo_scoreDetail" v-if="score">
          <a-rate :default-value="score" v-model="score" allow-half disabled>
            <template slot="character">
                <svg t="1689062632218" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="18179" id="mx_n_1689062632219" width="16" height="16"><path d="M847.499124 64.021106 175.912475 64.021106c-61.817927 0-111.931279 50.113351-111.931279 111.931279l0 671.586648c0 61.817927 50.113351 111.931279 111.931279 111.931279l671.586648 0c61.815881 0 111.931279-50.113351 111.931279-111.931279L959.430402 175.952384C959.430402 114.134457 909.315004 64.021106 847.499124 64.021106zM839.269695 443.469184 711.566198 549.509289c-11.830443 9.82374-16.949021 25.580608-13.153578 40.479947l40.98853 160.848385c8.894577 34.910091-29.433356 62.756299-59.884902 43.508933l-140.310629-88.684832c-12.998035-8.216125-29.565363-8.216125-42.566468 0L356.329545 794.346553c-30.451546 19.247366-68.777433-8.598842-59.882855-43.508933l40.98546-160.848385c3.796466-14.900362-1.323135-30.656207-13.153578-40.479947L196.576097 443.469184c-27.714202-23.011086-13.075807-68.069305 22.87294-70.396303l165.642574-10.723226c15.346523-0.994654 28.749788-10.732435 34.4363-25.019837l61.385069-154.219407c13.3214-33.471322 60.697407-33.471322 74.019831 0l61.385069 154.219407c5.688559 14.287401 19.092847 24.025183 34.4363 25.019837l165.642574 10.723226C852.345502 375.399879 866.985944 420.457074 839.269695 443.469184z" p-id="18180" fill="currentColor"></path></svg>
            </template>
          </a-rate>
          <!-- <a-rate  :default-value="score" allow-half disabled /> -->
          <!-- {{score|changeDecimal(2)}}<span>/10</span>  -->
        </p>
      </a>
    </div>
  </div>
</template>


<script>
import { mapState ,mapGetters, mapActions} from 'vuex';
import { digits2 } from "@/utils/baseFn/filter";
import { translate } from "@/utils/i18n"
export default {
name:'tokenInfo',
data() {
  return {
    value:{},
    tradeInfo:{},
    bitUrl:'',
    score:0
  }
},
computed: {
  ...mapState(['baseAsset','trade','upDown','local','TokenCode','quotePrecision','tickerDayList','tickSize','symbol']),
  ...mapGetters(['getSymbolTicker','getScore']),
  
},

watch: {
  getScore:{
    immediate:true,
    handler(val){
      console.log(val);
      this.score=val
    }
  },
   getSymbolTicker(e){
    let trade=this.trade.replace('/','')
    let info = {}
     info= e.filter(item=>{
        return item.symbol===trade
    })[0]||{}
    if(info.askPrice2!==undefined){
      this.tradeInfo=info
    }
    // this.setQp({tickSize:info.tickSize,stepSize:info.stepSize})
    const titlePrice = this.tradeInfo.askPrice2 || '';
    this.$nextTick(()=>{
      document.title =digits2(titlePrice,this.tickSize) + " " + translate('9130').replace('{0}', '').replace('{0', '').replace('{1}', this.baseAsset).replace('{1}', this.baseAsset).replace('{2}', '')
    })
  },
  // baseAsset:{
  //   immediate:true,
  //   handler(e){
  //     console.log(e);
  //     let trade=this.trade.replace('/','')
  //       this.tradeInfo=this.getSymbolTicker.filter(item=>{
  //           return item.symbol===trade
  //       })[0]||{}
  //       this.tradeInfo.askPrice2=this.tradeInfo.askPrice
  //       const titlePrice = this.tradeInfo.askPrice2 || '';
  //       this.$nextTick(()=>{
  //         document.title =digits2(titlePrice,this.tradeInfo.tickSize) + " " + translate('9130').replace('{0}', '').replace('{0', '').replace('{1}', e).replace('{1}', e).replace('{2}', '')
  //       })
  //   }
  // },
  trade:{
    immediate:true,
    handler(e){
      let trade=e.replace('/','')
      let baseAss=e.split('/')[0]
        this.tradeInfo=this.getSymbolTicker.filter(item=>{
            return item.symbol===trade
        })[0]||{}
        this.tradeInfo.askPrice2=this.tradeInfo.askPrice
        
        const titlePrice = this.tradeInfo.askPrice2 || '';
        this.$nextTick(()=>{
          document.title =digits2(titlePrice,this.tradeInfo.tickSize) + " " + translate('9130').replace('{0}', '').replace('{0', '').replace('{1}', baseAss).replace('{1}', baseAss).replace('{2}', '')
        })
    }
  },

  TokenCode(e){
  // if (this.local === 'zh-cn') {
  //     this.bitUrl = `https://www.wikibit.${getSuffix()}/zh-cn/tk/${e}.html`;
  //   } else if (this.local === 'id') {
  //     this.bitUrl = `https://www.wikibit.id/tk/${e}.html`
  //   } else {
  //   }
    this.bitUrl = `https://www.wikibit.com/${this.local}/tk/${e}.html`;

  }
},
created(){
  console.log(this.score);
},
mounted() {
  console.log(this.score);
  
  let url =location.href
  let local=url.split('/')[3]
  if(local!=='zh'&&local!=='zh-cn'&&local!=='en'&&local!=='ja'&&local!=='vi'&&local!=='id'){
      local='en'
    }
  if(url.includes('.html')){
      let str=url.replace('.html', '').split('/')
       let tokencode=str[str.length-1]
    //    if (local === 'zh-cn') {
    //   this.bitUrl = `https://www.wikibit.${getSuffix()}/zh-cn/tk/${tokencode}.html`;
    // } else if (local === 'id') {
    //   this.bitUrl = `https://www.wikibit.id/tk/${tokencode}.html`
    // } else {
    // }
    this.bitUrl = `https://www.wikibit.com/${local}/tk/${tokencode}.html`;
    }else{
    //    if (local === 'zh-cn') {
    //   this.bitUrl = `https://www.wikibit.${getSuffix()}/zh-cn/tk/6872731468202.html`;
    // } else if (local === 'id') {
    //   this.bitUrl = `https://www.wikibit.id/tk/6872731468202.html`
    // } else {
    // }
    this.bitUrl = `https://www.wikibit.com/${local}/tk/6872731468202.html`;
    }
},
methods: {
  ...mapActions(['setQp'])
},
}
</script>

<style lang="less">
.tokenInfo{
    text-align: left;
    height: 103px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid var(--line);
    border-top-left-radius: 2;
    border-top-right-radius: 2;
    padding: 7px 8px 7px 16px;
    color: var(--grey200);
    font-size: 12px;
    background-color: var(--grey800);
    .tokenInfo_symbol_name {
      padding: 10px 16px 0 0;
      flex-shrink: inherit;
      em {
         color: var(--fontWhite) !important;
        display: inline;
        font-style: normal;
         i {
          margin: -2px 0 0;
          color: var(--grey200);
        }
      }
       span.label {
        display: flex;
        margin-left: 8;
        padding: 0 2px;
        max-width: 34px;
        height: 20px;
        font-size: 12px;
        line-height: 18px;
        align-items: center;
        text-align: center;
        // color: theme.palette.primary.main;
        color: #008099;
        font-weight: 500;
        border: 1px solid #008099;
        border-radius: 2px;
        overflow: hidden;
        // border: `1px solid ${theme.palette.primary.main}`;
      }
    }
    .tokenInfo_symbolTitle {
      font-size: 22px;
      line-height: 26px;
      color: #fff;
      text-align: left;
       span {
        color: #fff;
        margin-left: 8px !important;
      }
    }
    .tokenInfo_symbolIconBox {
      display: flex;
    }
    .tokenInfo_symbolIcon {
      display: block;
      margin: 3px 8px 3px 0;
      height: 20px;
    }
    .tokenInfo_pricePrecision {
      display: block;
      text-align: left;
      padding: 2px 0;
      min-width: 120px;
    }
    .tokenInfo_price {
      margin: 2px 0 3px;
      font-weight: 500;
      font-size: 26px;
      line-height: 28px;
    }
    .tokenInfo_rates {
      font-size: 14px;
      line-height: 20px;
      color: var(--fontWhite) !important;
    }
    .tokenInfo_info {
      flex: 1;
      display: flex;
      flex-shrink: unset;
      // margin: 0 0 0 16px;
      justify-content: flex-start;
      flex-wrap: wrap;
      & div {
        font-size: 12px;
        padding: 0 16px 0 0;
        white-space: nowrap;
        
        & > span {
          color:var(--grey300);
          line-height: 20px;
        }
      }
    }
    .tokenInfo_infoCol {
      width: 200px;
    }
    .tokenInfo_infoRow {
      display: flex;
      width: 100%;
      
    }
    .tokenInfo_infoCell {
      margin: 0 0 8px;
      height: 20px;
      line-height: 20px;
      
      color: var(--grey200);
    }
    .tokenInfo_infoIntro {
      display: inline-block;
      
      padding: 0 5px;
      margin-right: 8px;
      min-width: 80px;
      text-align: right;
      background: var(--infoBg);
      border-radius: 2;
    }
    .tokenInfo_scoreBox {
      padding: 8px 8px;
      // width: 170px;
      height: 88px;
      display: flex;
      text-align: center;
      background-size: cover;
      background-color: rgba(230, 97, 18, 0.1);
      background-image: url("../../assets/market/score-bg.png");
      border: 1px solid rgba(230, 97, 18, 0.1);
      border-radius: 6px;
      a {
        display: block;
        width: 100%;
        height: 100%;
      }
      &:hover {
        background-color: rgba(230, 97, 18, 0.16);
      }
    }
    .tokenInfo_scoreTitle {
      margin: 0;
      line-height: 20px;
      margin-bottom: 10px;
      & span {
        margin-right: 4px;
        font-size: 18px;
        color: var(--fontWhite);
        vertical-align: middle;
      }
      & i {
        font-size: 14px;
        color: #e66112;
        vertical-align: bottom;
      }
    }
    .tokenInfo_scoreDetail {
      font-size: 40px;
      line-height: 20px;
      color: var(--scorePoint);
       span {
        font-size: 16px;
        line-height: 20px;
        color: var(--scoreTotal);
      }
    }
}
.ant-rate-star-zero{
  color: #e5e7ea;
}
.ant-rate-star-full .ant-rate-star-second{
  color: #e8712a;
}
.ant-rate-star-half .ant-rate-star-first{
  color: #e8712a;
}
</style>